import React, { useEffect, useRef, useState } from 'react'
import './languageSwitcher.sass'
import { useTranslator } from './translator'

export default function LanguageSwitcher() {
  const { lang, languages, setLang } = useTranslator()
  let [open, setOpen] = useState(false)
  let parentRef = useRef(null)

  const handleGlobalClick = e => {
    if (parentRef.current && parentRef.current.contains(e.target)) return
    setOpen(false)
  }

  useEffect(() => {
    if (open) {
      document.addEventListener('click', handleGlobalClick)
      document.addEventListener('touchstart', handleGlobalClick)
    } else {
      document.removeEventListener('click', handleGlobalClick)
      document.removeEventListener('touchstart', handleGlobalClick)
    }
    return () => {
      document.removeEventListener('click', handleGlobalClick)
      document.removeEventListener('touchstart', handleGlobalClick)
    }
  }, [open])

  let label = languages[lang]

  let classes = ['language-switcher']
  if (open) classes.push('language-switcher--open')

  return (
    <div className={classes.join(' ')} ref={parentRef}>
      <button className="language-switcher-button" onClick={e => e.preventDefault() & setOpen(open === false)}>
        <i className="fa fa-globe" />
        {label}
      </button>
      <div className="language-switcher-list">
        {Object.keys(languages).map(l => {
          let classes = ['language-switcher-item']
          if (lang === l) classes.push('language-switcher-item--active')

          return (
            <button
              className={classes.join(' ')}
              key={l}
              onClick={e => {
                e.preventDefault()
                setLang(l)
                setOpen(false)
              }}>
              {languages[l]}
            </button>
          )
        })}
      </div>
    </div>
  )
}
